// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e-IM","fullView":"styles_fullView__1sHdH"};